import React from "react";
import { ArrowUp, Phone, ShieldCheck } from "@phosphor-icons/react";
import { ClassicTestimonials } from "../BuyerTestimonials";
import { SharedCaseResults, SharedTrustBar } from "../SharedSections";

const BADGES = ["Free case review", "No fee unless you win", "100% confidential"];

// First page: credibility copy beside the accident-type tiles.
export function QuizV2Entry({ vertical, page }) {
  const kicker = vertical.urgencyBadge || vertical.kicker;
  return (
    <div className="qv2-copy" data-testid="quiz-v2-entry-copy">
      {kicker && <span className="qv2-kicker">{kicker}</span>}
      <h1 className="qv2-h1" data-testid="quiz-v2-headline">{vertical.headline}</h1>
      {vertical.headlineAccent && <p className="qv2-accent">{vertical.headlineAccent}</p>}
      {vertical.subheadline && <p className="qv2-sub">{vertical.subheadline}</p>}
      {(page.stats || []).length > 0 && (
        <div className="qv2-stats" data-testid="quiz-v2-stats">
          {page.stats.slice(0, 3).map((s, i) => (
            <div className="qv2-stat" key={i}><b>{s.number}</b><span>{s.label}</span></div>
          ))}
        </div>
      )}
      <ul className="qv2-badges">
        {BADGES.map((b) => <li key={b}><ShieldCheck size={16} weight="fill" aria-hidden="true" />{b}</li>)}
      </ul>
      {vertical.firmName && (
        <p className="qv2-firm" data-testid="quiz-v2-firm">Your case is reviewed by <strong>{vertical.firmName}</strong>.</p>
      )}
    </div>
  );
}

// Question screens: brand mark, short headline, optional small call button.
export function QuizV2Top({ brand, logo, phone, buyerCode }) {
  return (
    <div className="qv2-flowtop" data-testid="quiz-v2-flow-top">
      <div className="qv2-flowbar">
        <div className="qv2-mark" data-testid="quiz-v2-brand">
          {logo ? <img src={logo} alt={`${brand} logo`} /> : <span className="qv2-dot" />}
          <span>{brand}</span>
        </div>
        {phone && (
          <a className="qv2-call" href={`tel:${phone.replace(/[^0-9+]/g, "")}`} data-lp-cta="phone"
             data-lp-buyer={buyerCode || undefined} data-testid="quiz-v2-call-btn">
            <Phone size={14} weight="fill" aria-hidden="true" />Call
          </a>
        )}
      </div>
      <h1 className="qv2-flow-h1" data-testid="quiz-v2-flow-headline">Your free case review</h1>
      <p className="qv2-flow-sub">About 60 seconds · Free and confidential</p>
    </div>
  );
}

// Below the fold on the first page only: proof and testimonials.
export function QuizV2Proof({ page, buyerCode }) {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  return (
    <div className="qv2-proof" data-testid="quiz-v2-proof">
      <SharedTrustBar />
      {(page.content_sections || []).length > 0 && (
        <section className="lp-section" aria-label="Details">
          {page.content_sections.map((c, i) => (
            <div key={i} style={{ marginBottom: 40 }} data-testid={`quiz-v2-section-${i}`}>
              <h2 className="lp-section-title">{c.title}</h2>
              <p className="lp-section-sub" style={{ whiteSpace: "pre-line" }}>{c.body}</p>
            </div>
          ))}
        </section>
      )}
      <ClassicTestimonials code={buyerCode} />
      <SharedCaseResults testId="quiz-v2-case-results" />
      <section className="qv2-final">
        <h2>See if you have a case in about 60 seconds</h2>
        <button type="button" onClick={toTop} data-testid="quiz-v2-back-to-top">
          Pick your accident type <ArrowUp size={16} weight="bold" aria-hidden="true" />
        </button>
      </section>
    </div>
  );
}
